import {
    DeleteOutlined,
    DownloadOutlined, EditOutlined, ExportOutlined, EyeOutlined, FileAddOutlined, FolderViewOutlined, FormOutlined,
    LoadingOutlined,
    StarFilled
} from '@ant-design/icons';
import {Button, Card, Dropdown, Popconfirm, Popover, Tooltip} from "antd";
import React, {useState} from "react";
import * as PropTypes from "prop-types";
import {getDisplayDimensions, getMaxDimensions, getTemplateSize} from "../Wizard/utils";
import {AodIcon} from "../AodUi/AodIcon";
import {getQueryString} from "../aodApi/aodUtils";
import {MeasureImg} from "./Helpers";
import "./ItemCard.css";


// .wizard-card  .ant-card-actions > li {margin: 0}
export default function ItemCard(
    {
        description,
        title,
        thumbSize,
        previewSize,
        asset={},
        type,
        size= 'small',
        urlParams,
        onClick,
        ...props
    }) {

    return <Card
        className='wizard-card'
        cover={<CardCover {...{asset,thumbSize,previewSize,type,urlParams, onClick}} />}
        style={{display: "inline-block", margin: 5}}
        size={size}
        {...props}>
        <Card.Meta {...{title,description}} style={{maxWidth:200}}/>
    </Card>;
}


const CardButton = (
    {
        onClick=()=>{}, asset,
        title, placement='bottom', style,
        icon,
        confirmDelete,
        ...props
    })=>
    <Tooltip {...{title, placement}}>
        {confirmDelete 
            ? <Popconfirm title={'Comfirm delete'}
                          okText={'Delete'}
                          onConfirm={()=>onClick(asset)}>
                <Button type='link' icon={icon}
                        style={{color: "teal",...style}}
                        {...props}
                />
            </Popconfirm>
            : <Button type='link' icon={icon}
                    onClick={()=>onClick(asset)}
                    style={{color: "teal",...style}}
                    {...props}
            />}
    </Tooltip>;

function CardCover(
    {
        previewSize = 500,
        thumbSize= 150,
        urlParams,
        asset={},
        type= '',
        onClick,
        ...props
    })
{
    const [width, setWidth] = useState(0);
    const [height, setHeight] = useState(0);
    // Control the popover so we can prevent loading of previews until rollover (& we have dimensions)
    const [popoverVisible, setPopupVisible] = useState(false);

    //Todo tweek width based on aspect ratio / type
    // banner - wider
    // portrait - shrink to text size
    //Note:  Card.Meta MUST have a non-space description - or the card doesn't flow the same as others - screwed up..
    //<MeasureImg src={asset.thumbUrl} onMeasure={(dims)=>do what exactly...}/>

    const thumbBoxStyle = {
        height: thumbSize, //make prop  - could pull in prevUrl if large
        minWidth: thumbSize,   // expands to width of card,  dictated by text
        position: 'relative'
    };
    const thumbStyle = {
        maxWidth: '100%', maxHeight: '100%',
        margin: '0px auto',
        position: 'absolute',
        bottom: 0, right: 0, left: 0
    };

    const iconStyle ={
        fontSize: thumbSize *0.8,
        color: 'lightgray'
    }

    const {thumbUrl, previewUrl, type:assetType, itemCall} = asset;
    const extraParams = getQueryString(urlParams,true);

    // todo figure out "aodType"
    // Sales sheets already have an internal type - Sole_AD or SALEs_PRESENTATION - useful
    // people have personType - accountPerson, advertiserPerson - ? just related to owner

    let aodType =  assetType || type ;
    if (itemCall && asset[itemCall+'Type']){
        aodType = asset[itemCall+'Type'];
    }

    const altName = asset.name | asset.file_name || 'file';

    return (
        <div style={thumbBoxStyle}>
        {
            thumbUrl
            ? (previewUrl
                ?<>
                    {width===0 && popoverVisible &&
                        <MeasureImg src={previewUrl+extraParams}
                                    onMeasure={({width,height})=>{
                                        setHeight(height);
                                        setWidth(width);
                                    }} />}
                    <Popover placement='left'
                             visible={popoverVisible}
                             onVisibleChange={setPopupVisible}
                             content={ popoverVisible && (width===0
                                 ? <LoadingOutlined/>
                                 : <div style={getMaxDimensions(previewSize,{width,height})}>
                                     <img src={previewUrl+extraParams} style={{width: "100%", height: "100%"}}
                                          alt={altName} onClick={onClick}/>
                                 </div>)}
                    >
                        <img src={thumbUrl+extraParams} style={thumbStyle} alt={altName}
                            onClick={onClick}/>
                    </Popover>
                </>
                :
                <img src={thumbUrl+extraParams} style={thumbStyle} alt={altName}
                    onClick={onClick}/>
            )
            : <AodIcon type={aodType} style={{...iconStyle, ...thumbStyle}}/>
        }
        </div>
    );
}

//todo ?line support
function CardDescription({style, children, ...props}){
    return <div style={{
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        ...style
    }}>{children}</div>
}


export function AssetCard(
    {
        asset ={},
        onClick,
        type= 'asset',
        ...props
    }) {

    return (
        <ItemCard

            onClick={onClick}
            description={getTemplateSize(asset)}
            {...{asset, type}}
            {...props}
        />
    );
}
AssetCard.propTypes = {
    previewSize: PropTypes.number,
    thumbSize: PropTypes.number,
    asset: PropTypes.any,
    onClick: PropTypes.func
};
// No Action buttons ?
/*
actions={[
                    <CardButton icon={<StarFilled/>} onClick={onClick}
                                title={'Select this template'}/>
                ]}
 */

export function SalesSheetCard(
    {
        asset ={},
        onOpen, onAppend, onDelete, onPresent,
        shareMenu,
        type= 'salesSheet',
        ...props
    }) {

    const {salesRep, advertiserName, updatedDate} = asset;

    // todo ?show advertiser if not part of filter
    // todo clickable advertiser & salesRep
    // todo generate actions lisr based on passed functions

    return <ItemCard
        actions={[
            <CardButton icon={<AodIcon type={'salesSheet'}/>} onClick={onOpen}
                        title={'View presentation'}/>,
            <CardButton icon={<FileAddOutlined/>} onClick={onAppend}
                        title={'Add new spec ad'}/>,
            <Dropdown overlay={shareMenu} >
                <CardButton icon={<ExportOutlined/>} />
            </Dropdown>,
            <CardButton icon={<FolderViewOutlined/>} onClick={onPresent}
                        title={'Present mode'}/>,
            <CardButton icon={<DeleteOutlined/>} onClick={onDelete}  confirmDelete={true}/>
        ]}
        onClick={onOpen}
        title={asset.name}
        description={<CardDescription>
            <AodIcon type={'advertiser'}/> {advertiserName}<br/>
            {asset.salesRep &&
                <span><AodIcon type={'salesRep'}/> {salesRep.firstName} {salesRep.lastName}<br/></span>}
            <span>{updatedDate.toDateString()}</span>
        </CardDescription>}
        {...{asset, type}}
        urlParams={{useSoloSpecAd:true}}
        {...props}
    />;
}

export function SpecAdCard(
    {
        asset ={},
        onCopy,onDelete,onMcc,onView,
        shareMenu, downloadMenu,
        type= 'specAd',
        ...props
    }) {

    return <ItemCard
        actions={[
            <Dropdown overlay={shareMenu} >
                <CardButton icon={<ExportOutlined/>} />
            </Dropdown>,
            <Dropdown overlay={downloadMenu} >
                <CardButton icon={<DownloadOutlined/>} />
            </Dropdown>,
            <CardButton icon={<FormOutlined />} onClick={onCopy}
                        title={'Edit in Wizard'}/>,
            <CardButton icon={<AodIcon type={'template'}/>} onClick={onMcc}
                        title={'View in Creative Library to access production files'}/>,
            <CardButton icon={<DeleteOutlined/>} onClick={onDelete} confirmDelete={true}/>
        ]}
        onClick={onView}
        title={asset.jobNumber || asset.metroReference}
        description={<span>
            {getDisplayDimensions(asset)}<br/>
            {asset.metroSpecAd}
        </span>}
        {...{asset, type}}
        {...props}
    />;
}

//{getDate(asset.createdDate).toDateString()}